<template>
  <div class="miya-purchaseAgent" id="miya-purchaseAgent">
    <div class="pageBox">
      <h1 class="title1 fontSH">{{ $t("pAgent.title1") }}</h1>
      <div class="form-box">
        <div class="row">
          <p class="name">
            <span>{{ $t("pAgent.country") }}</span>
            <!-- <el-tooltip class="item" effect="dark" :content="$t('pAgent.countryTip')" placement="bottom">
              <img src="@assets/images/icon/tip.svg">
            </el-tooltip> -->
          </p>
          <div
            style="
    display: flex;
    flex-wrap:wrap;
"
          >
            <el-radio
            style="width:238px;"
              v-for="(item, idx) in countryList"
              :key="'country' + idx"
              v-model="ruleForm.country"
              :label="item.value"
              border
              >{{ item.label }}</el-radio
            >
          </div>
          <!-- <el-select size="medium" :placeholder="$t('pAgent.country')" v-model="ruleForm.country">
            <el-option v-for="(item, idx) in countryList" :key="'country'+idx" :label="item.label" :value="item.value"></el-option>
          </el-select> -->
        </div>
        <div class="row">
          <p class="name">
            <span>{{ $t("pAgent.ipType") }}</span>
            <span class="tip" v-show="ruleForm.ipType === 'ispshare'">{{
              $t("pAgent.ipTypeTip")
            }}</span>
          </p>
          <check-list
            :list="dataList"
            :default="[ruleForm.ipType]"
            @change="changeTypeChecked"
          ></check-list>
          <div class="type-price">
            <span class="priceText" v-if="ruleForm.ipType === 'ispone'">{{
              $t("pAgent.price1")
            }}</span>
            <span class="priceText" v-if="ruleForm.ipType === 'ispshare'">{{
              $t("pAgent.price2")
            }}</span>
            <span class="usd">$</span>
            <span class="price"
              >{{
                dataList.find((val) => {
                  return val.value === ruleForm.ipType;
                }).price + ".00"
              }}
            </span>
            <span class="unit">{{ $t("pAgent.priceUnit") }}</span>
          </div>
        </div>
        <div class="row">
          <p class="name">
            <span>{{ $t("pAgent.ipTime") }}</span>
            <!-- <el-tooltip class="item" effect="dark" :content="$t('pAgent.ipTimeTip')" placement="bottom">
              <img src="@assets/images/icon/tip.svg">
            </el-tooltip> -->
          </p>
          <check-list
            :list="dayList"
            :default="[ruleForm.month]"
            @change="changeDayChecked"
          ></check-list>
        </div>
        <div class="row">
          <p class="name">
            <span>{{ $t("pAgent.ipNumber") }}</span>
            <span class="tip">{{ $t("pAgent.maxIPNum") }}</span>
          </p>
          <el-input-number
            style="width:220px;"
            size="medium"
            v-model="num"
            :step="1"
            :precision="0"
            :min="1"
            :max="100"
            :step-strictly="true"
            @change="changeNum()"
          ></el-input-number>
        </div>
        <div class="row">
          <p class="name">
            <span>{{ $t("pTraffic.discountCode") }}</span>
          </p>
          <el-input
            size="medium"
            :class="{ error: discountCodeError }"
            clearable
            @clear="clearDiscountCode()"
            :placeholder="$t('pTraffic.placeholderDc')"
            v-model="discountCode"
            @change="changeDc()"
          ></el-input>
          <p class="discountCodeError" v-if="discountCodeError">
            {{ discountCodeError }}
          </p>
        </div>
      </div>
      <div class="price-box">
        <div class="discountCode">
          <div class="selectIP">
            <img
              v-if="ruleForm.ipType === 'ispone'"
              class="icon"
              src="@assets/images/home/price-icon3.png"
            />
            <img
              v-if="ruleForm.ipType === 'ispshare'"
              class="icon"
              src="@assets/images/home/price-icon4.png"
            />
            <span class="select">{{ $t("pAgent.select") }}IP</span>
            <span class="select1" v-if="ruleForm.ipType === 'ispone'"
              >&nbsp;{{ $t("pAgent.type1") }}IP</span
            >
            <span class="select1" v-if="ruleForm.ipType === 'ispshare'"
              >&nbsp;{{ $t("pAgent.type2") }}IP</span
            >
          </div>
          <div class="selectTotal">
            <span class="countryText">{{ $t("pAgent.country") }}</span>
            <span class="country">{{
              countryList.find((val) => {
                return val.value === ruleForm.country;
              }).label
            }}</span>
            <span class="ipText">{{ $t("pAgent.ipTime") }}</span>
            <span class="country weight">{{ getSelectDay() }}</span>
            <span class="unit">[{{ getSelectUnit() }}]</span>
            <span class="ipText">{{ $t("pAgent.ipNumber") }}</span>
            <span class="country weight">{{ num }}</span>
            <span class="unit">[{{ $t("dashboard.orders") }}]</span>
          </div>
        </div>
        <div class="price">
          <p class="amountLabel">{{ $t("pTraffic.amount") }}</p>
          <p class="usd">$</p>
          <p class="amount">{{ amount }}</p>
          <p class="old" v-if="discountCode && !discountCodeError">
            ${{ oldAmount }}
          </p>
        </div>
        <div class="btns">
          <div class="info-btn">
            <el-button
              style="width: 100%;border-radius:0;"
              type="info"
              @click="clickUSDT()"
              >{{ $t("pTraffic.btnUsdt") }}</el-button
            >
          </div>
          <miya-btn
            class="payBtn"
            ref="miyaBtn1"
            :title="$t('pTraffic.otherPay')"
            @click="clickPayBtn()"
          >
            <template slot="icon">
              <i
                class="icon-caret"
                :class="
                  showPayBox ? 'el-icon-caret-bottom' : 'el-icon-caret-top'
                "
              ></i>
            </template>
          </miya-btn>
          <div
            class="pay-box"
            v-show="showPayBox"
          >
            <div class="pay-box1" >
              <div class="item" @click.stop="clickPay('alipay')">
                <img class="icon" src="@assets/images/dynamic/zfb.png" /><span
                  >{{ $t("pTraffic.Alipay") }}</span
                >
                <div class="line"></div>
              </div>
              <div class="item" @click.stop="clickPay('native')">
                <img class="icon" src="@assets/images/dynamic/vx.png" /><span>{{
                  $t("pTraffic.WeChat")
                }}</span>
                <div class="line"></div>
              </div>
              <!-- <div class="item" @click.stop="clickPay('stripe')">
                <img class="other1" src="@assets/images/dynamic/other1.png" />
              </div> -->
              <div class="item" @click.stop="clickPay('useepay')">
                <img class="other1" src="@assets/images/dynamic/other1.png" />
              </div>
              <!-- <div class="item" @click.stop="clickPay('paypal')">
                <img class="other1" src="@assets/images/dynamic/pp_fc_hl.svg" />
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <el-dialog
        :title="loadQr ? '' : $t('pTraffic.payUSDT')"
        :visible.sync="dialogTableUSDT"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :width="loadQr ? '240px' : '360px'"
      >
        <div class="qrImg" v-if="loadQr">
          <img class="loading" src="@assets/images/home/load.gif" />
          <p class="text">{{ $t("pTraffic.loading") }}</p>
        </div>
        <div class="usdt-box" v-if="!loadQr">
          <p class="usdt">
            <span class="value">{{ USDT }}</span
            ><span class="unit">USDT</span>
          </p>
          <p class="old" v-show="discount < 1">
            <span class="value">{{ oldUSDT }}</span
            ><span class="unit">USDT</span>
          </p>
        </div>
        <div class="dialog-footer" v-if="!loadQr">
          <el-button
            class="ok"
            type="info"
            size="medium"
            :disabled="usdtSurplus < USDT"
            @click.stop="clickPayUSDT()"
            >{{
              usdtSurplus < USDT ? $t("login.balance1") : $t("pTraffic.payOk")
            }}</el-button
          >
          <div class="cancel-usdt">
            <span @click.stop="dialogTableUSDT = false">{{
              $t("pTraffic.payCancel")
            }}</span>
          </div>
        </div>
      </el-dialog>
      <el-dialog
        :title="payTitle"
        :visible.sync="dialogTablePayCode"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :width="loadQr ? '240px' : '360px'"
      >
        <div class="qrImg" v-if="loadQr">
          <img class="loading" src="@assets/images/home/load.gif" />
          <p class="text">{{ $t("pTraffic.loading") }}</p>
        </div>
        <div class="qrImg" v-if="!loadQr">
          <img class="qrcode" :src="payQr" />
        </div>
        <div class="pay-dialog-price" v-if="!loadQr">
          <label class="name">{{ $t("pTraffic.amount") }}</label>
          <span class="old" v-show="discount < 1">￥{{ odlAmountRMB }}</span>
          <span class="unit">￥</span>
          <span class="amount">{{ amountRMB }}</span>
        </div>
        <div class="pay-footer" v-if="!loadQr">
          <el-button
            class="cancel miyaBtnInfo"
            type="info"
            size="medium"
            plain
            @click.stop="dialogTablePayCode = false"
            >{{ $t("pTraffic.payCancel") }}</el-button
          >
          <el-button
            class="ok"
            type="info"
            size="medium"
            @click.stop="$router.push('/historicalOrders')"
            >{{ $t("pTraffic.paid") }}</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
        class="dialogAdyen"
        :show-close="false"
        :visible.sync="dialogAdyen"
        :modal-append-to-body="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :width="pageWidth < 900 ? '90%' : '900px'"
        :top="pageWidth < 900 ? '5vh' : '10vh'"
      >
        <div class="adyenContent">
          <div class="close" @click="dialogAdyen = false">
            <i class="el-icon-close"></i>
          </div>
          <div class="dropin-container" id="dropin-container"></div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import miyaBtn from "@components/miyaBtn.vue";
import checkList from "@components/checkList.vue";
import AdyenCheckout from "@adyen/adyen-web";
import { purchaseCity, dayList } from "@assets/js/data.js";
export default {
  data() {
    return {
      countryList: purchaseCity,
      ruleForm: {
        country: "us",
        ipType: "ispone",
        month: 3,
      },
      dataList: [
        { value: "ispone", name: "", price: 6 },
        { value: "ispshare", name: "", price: 3 },
      ],
      dayList: dayList,
      num: 1,
      amount: 0,
      oldAmount: 0,
      discount: 1,
      discountCode: "",
      priceTop: 0,
      USDT: 0,
      oldUSDT: 0,
      dialogTableContact: false,
      showPayBox: false,
      dialogTableUSDT: false,
      dialogTablePayCode: false,
      amountRMB: 0,
      odlAmountRMB: 0,
      payQr: "",
      discountCodeError: "",
      loadQr: false,
      payType: "",
      orderId: "",
      dialogAdyen: false,
    };
  },
  computed: {
    usdtSurplus() {
      return this.user.usdtSurplus || 0;
    },
    payTitle() {
      if (this.loadQr) {
        return "";
      } else {
        let type = "";
        if (this.payType === "alipay") {
          type = this.$t("pTraffic.Alipay");
        } else if (this.payType === "native") {
          type = this.$t("pTraffic.WeChat");
        }
        return `${type}${this.$t("pTraffic.payCode")}`;
      }
    },
    ...mapGetters(["user"]),
  },
  created() {
    let query = this.$route.query;
    if (query && query.type) {
      this.ruleForm.ipType = query.type === "ispone" ? "ispone" : "ispshare";
      this.changeNum();
    }
  },
  mounted() {
    this.getData();
    this.changeNum();
  },
  methods: {
    getData() {
      this.dataList[0].name = this.$t("pAgent.type1");
      if (this.dataList.length >= 2) {
        this.dataList[1].name = this.$t("pAgent.type2");
      }
      this.dayList.map((val, idx) => {
        if (idx < 4) {
          val.name = `${val.value * 30} ${this.$t("pAgent.day")}`;
        } else {
          val.name = `${idx - 3} ${this.$t("pAgent.year")}`;
        }
      });
    },
    changeNum() {
      let obj = this.dataList.find((val) => {
        return val.value === this.ruleForm.ipType;
      });
      this.oldAmount = this.num * obj.price * this.ruleForm.month;
      this.amount = Number((this.oldAmount * this.discount).toFixed(2));
    },
    clearDiscountCode() {
      this.discount = 1;
      this.changeNum();
    },
    changeDc() {
      // 获取折扣码
      if (this.discountCode) {
        this.$get(
          `/ProxyBuy/DiscountInfo?discountKey=${this.discountCode}`
        ).then((res) => {
          if (res.code === 200) {
            this.discount = Number(res.result);
            this.changeNum();
            this.discountCodeError = "";
          } else if (res.code === 500) {
            this.discountCodeError = this.$t("pTraffic.discountCodeError");
          }
        });
      }
    },
    clickPay(type) {
      // 其他支付
      // if (type === 'adyen') {
      //   this.$message.warning(this.$t('pTraffic.commingSoon'))
      //   return
      // }
      this.showPayBox = false;
      this.dialogTablePayCode = true;
      this.payType = type;
      let data = {
        payType: type,
        shopType: this.ruleForm.ipType,
        country: this.ruleForm.country,
        mealnum: this.num,
        month: this.ruleForm.month,
        discountKey: this.discountCode, // miya6zhe
      };
      this.loadQr = true;
      this.$get(`/ProxyBuy/Get`, data).then((res) => {
        this.loadQr = false;
        if (res.code === 200) {
          if (this.payType === "adyen") {
            this.loadQr = true;
            this.getConfiguration(
              res.result.checkoutSessionid,
              res.result.sessionData
            );
          } else if (this.payType === "useepay") {
            window.open(res.result.sessionData, "_blank");
          } else if (this.payType === "stripe") {
            window.open(res.result.sessionData, "_blank");
          } else if (this.payType === "paypal") {
            window.open(res.result.sessionData, "_blank");
          } else if (this.payType === "rucredit") {
            window.open(res.result.payssionPayUrl, "_blank");
          } else {
            this.payQr = res.result.qr;
          }
          this.amountRMB = res.result.price;
          this.odlAmountRMB = Number(
            (res.result.price / this.discount).toFixed(2)
          );
        } else {
          this.dialogTablePayCode = false;
          this.$message.error(res.message);
        }
      });
    },
    async getConfiguration(sessionid, sessionData) {
      const configuration = {
        environment: "live", // Change to 'live' for the live environment.
        clientKey: "live_OX724TTSUZG7ZE5KUZF3EBMXRILZHW73", // Public key used for client-side authentication: https://docs.adyen.com/development-resources/client-side-authentication
        analytics: {
          enabled: true, // Set to false to not send analytics data to Adyen.
        },
        session: {
          id: sessionid, // Unique identifier for the payment session.
          sessionData: sessionData, // The payment session data.
        },
        onPaymentCompleted: (result, component) => {
          console.info(result, component);
        },
        onError: (error, component) => {
          console.error(error.name, error.message, error.stack, component);
        },
        // Any payment method specific configuration. Find the configuration specific to each payment method:  https://docs.adyen.com/payment-methods
        // For example, this is 3D Secure configuration for cards:
        paymentMethodsConfiguration: {
          card: {
            hasHolderName: true,
            holderNameRequired: true,
            billingAddressRequired: true,
          },
        },
      };
      const checkout = await AdyenCheckout(configuration);

      this.loadQr = false;
      this.dialogTablePayCode = false;
      this.dialogAdyen = true;
      this.$nextTick(() => {
        const dropinComponent = checkout
          .create("dropin")
          .mount("#dropin-container");
        dropinComponent.update();
      });
    },
    clickUSDT() {
      // USDT生成订单
      let data = {
        payType: "usdt",
        shopType: this.ruleForm.ipType,
        country: this.ruleForm.country,
        mealnum: this.num,
        discountKey: this.discountCode,
        month: this.ruleForm.month,
        realPay: 0,
      };
      this.dialogTableUSDT = true;
      this.loadQr = true;
      this.$get(`/ProxyBuy/Get`, data).then((res) => {
        this.loadQr = false;
        if (res.code === 200) {
          // this.orderId = res.result.orderId
          this.USDT = res.result.priceDao;
          this.oldUSDT = Number(
            (res.result.priceDao / this.discount).toFixed(2)
          );
        } else {
          this.$message.error(res.message);
        }
      });
    },
    clickPayUSDT() {
      // USDT支付
      let data = {
        payType: "usdt",
        shopType: this.ruleForm.ipType,
        country: this.ruleForm.country,
        mealnum: this.num,
        discountKey: this.discountCode,
        month: this.ruleForm.month,
        realPay: 1,
      };
      this.loadQr = true;
      this.$get(`/ProxyBuy/Get`, data).then((res) => {
        if (res.code === 200) {
          this.orderId = res.result.orderId;
          this.$get(`/ProxyBuy/UsdtCallback?orderId=${this.orderId}`).then(
            (res1) => {
              this.loadQr = false;
              this.dialogTableUSDT = false;
              if (res1.code === 200) {
                this.$message.success(this.$t("login.success"));
                setTimeout(() => {
                  this.$get(`/Check/GetInfo`).then((res2) => {
                    if (res2.code === 200) {
                      this.$store.commit("set_user", res2.result);
                    }
                  });
                }, 200);
              } else {
                this.$message.error(res1.message);
              }
            }
          );
        } else {
          this.loadQr = false;
          this.dialogTableUSDT = false;
          this.$message.error(res.message);
        }
      });
    },
    changeTypeChecked(list) {
      this.ruleForm.ipType = list[0].value;
      this.changeNum();
    },
    changeDayChecked(list) {
      this.ruleForm.month = list[0].value;
      this.changeNum();
    },
    getSelectDay() {
      let idx = this.dayList.findIndex((val) => {
        return val.value === this.ruleForm.month;
      });
      if (idx < 4) {
        return this.dayList[idx].value * 30;
      } else {
        return idx - 3;
      }
    },
    getSelectUnit() {
      let idx = this.dayList.findIndex((val) => {
        return val.value === this.ruleForm.month;
      });
      if (idx < 4) {
        return this.$t("pAgent.day");
      } else {
        return this.$t("pAgent.year");
      }
    },
    clickPayBtn() {
      this.showPayBox = !this.showPayBox;
      // if (this.pageWidth < 800 && !this.showPayBox) {
      //   this.showPayBox = !this.showPayBox;
      // }
    },
  },
  watch: {
    "ruleForm.country": function(newVal, oldVal) {
      if (
        newVal == "de" ||
        newVal == "ph" ||
        newVal == "hk" ||
        newVal == "tw" ||
        newVal == "sg"
      ) {
        this.dataList = [{ value: "ispone", name: "", price: 6 }];
      } else {
        this.dataList = [
          { value: "ispone", name: "", price: 6 },
          { value: "ispshare", name: "", price: 3 },
        ];
      }
      this.getData();
    },
    language() {
      this.getData();
    },
    discountCode() {
      if (this.discountCode.length === 0) {
        this.discountCodeError = "";
      }
    },
  },
  components: { miyaBtn, checkList },
};
</script>
<style scoped lang="stylus">
.el-radio.is-bordered+.el-radio.is-bordered{
  margin-left:0px !important;
}
.miya-purchaseAgent
  height 100%
  overflow-y hidden
  .pageBox
    min-height 100%
    padding 40px 40px 24px 40px
    position relative
  .title1
    color $c1
    font-size 28px
    margin 10px 0 32px 0
  .form-box
    padding-bottom 180px
    .row
      width 50%
      margin-right 40px
      margin-bottom 36px
      line-height 20px
      position relative
      .discountCodeError
        color $c10
        font-size $f12
      .name
        display flex
        font-size $f14
        margin-bottom 10px
        color $c1
        fontWeight()
        .tip
          color $c2
          margin-left 10px
          font-weight 300
        img
          width 14px
          margin 0 38px 0 8px
        .text
          color $c2
          font-weight 300
          margin-left 16px
      &:nth-of-type(2n)
        margin-right 0
      .type-price
        position absolute
        bottom 12px
        right 0
        font-size $f14
        .priceText
          color $c1
          margin-right 30px
        .usd, .price
          color $c8
          fontWeight()
        .usd
          position relative
          bottom 1px
          font-size $f12
          margin-right 4px
        .price
          font-size $f18
          margin-right 6px
        .unit
          color $c2
  .price-box
    position absolute
    z-index 5
    left 0
    bottom 0
    width 100%
    border-top 1px solid $c4
    background-color $c7
    display flex
    .discountCode
      position absolute
      bottom calc(100% + 1px)
      background-color $c7
      left 0
      width 100%
      padding 6px 36px
      line-height 24px
      color $c1
      font-size $f14
      .selectIP, .selectTotal
        display flex
      .selectIP
        margin-bottom 2px
      .icon
        width 24px
        margin-right 6px
      .select, .select1
        fontWeight()
        font-size $f16
      .select1
        color $c8
        margin-right 4%
      .countryText
        color $c2
        margin-right 10px
      .country
        color $c8
        fontWeight()
      .ipText
        margin-left 3%
      .weight
        font-size $f20
        fontWeight()
        margin 0 6px
        position relative
        bottom 2px
    .price
      padding 16px 0 16px 36px
      line-height 36px
      display flex
      flex 1
      .amountLabel
        font-size $f14
        color $c1
        margin-right 20px
        position relative
        top 6px
      .usd
        color $c8
        font-size $f24
        margin-right 8px
        fontWeight()
        position relative
        top 2px
      .amount
        color $c8
        font-size 36px
        fontWeight()
        margin-right 16px
      .old
        color $c2
        font-size $f16
        text-decoration: line-through
        position relative
        top 6px
    .btns
      display flex
      .info-btn
        padding 13px 0
        width 160px
      .payBtn
        margin-left 36px
        width 220px
        color $c7
        text-align center
        line-height 68px
        background: linear-gradient(95deg, #FF8F10 0%, #FF7010 100%);
        .icon-caret
          margin-left 6px
      .pay-box
        z-index 999
        position absolute
        bottom 100%
        right 0
        width 220px
        background-color $c7
        padding-bottom 12px
        .pay-box1
          box-shadow: 0px 6px 12px 1px rgba(20,17,14,0.12)
          .item
            display flex
            height 64px
            padding 22px
            line-height 20px
            color $c1
            font-size $f16
            position relative
            cursor pointer
            .icon
              width 20px
              margin-right 12px
            .line
              position absolute
              width calc(100% - 44px)
              height 1px
              bottom 0
              left 22px
              background-color $c4
            &:hover
              background-color #F6F6F6
            .other1
              height 24px
  .usdt-box
    padding 56px 0
    text-align center
    .usdt
      color $c10
      margin-bottom 24px
      .value
        font-size 40px
        margin-right 8px
      .unit
        font-size $f14
    .old
      color $c2
      position relative
      display inline-block
      margin 0 auto
      padding 0 4px
      line-height 12px
      .value
        font-size $f24
        margin-right 8px
      .unit
        font-size $f14
      &:before
        content ''
        position absolute
        width 100%
        height 1px
        background-color $c2
        top 50%
        left 0
  .pay-footer
    display flex
    padding-bottom 24px
    .ok, .cancel
      flex 1
  .dialog-footer
    padding-bottom 24px
    .disabeld
      color $c10
      text-align center
      padding-bottom 8px
  .pay-dialog-price
    margin 42px 0 12px 0
    display flex
    line-height 24px
    .name
      font-size $f14
      fontWeight()
      flex 1
    .old
      color $c2
      font-size $f14
      margin-right 12px
      text-decoration: line-through
    .unit
      color $c10
      font-size $f16
      margin-right 6px
    .amount
      color $c10
      font-size $f24
      position relative
      top -3px
  .qrImg
    .qrcode, .loading
      display block
      margin 0 auto
    .loading
      width 124px
      margin-top 2px
    .qrcode
      margin-top 12px
    .text
      padding 24px 0 42px 0
      text-align center
      font-size $f14
      color $c2
      line-height 22px
  .cancel-usdt
    text-align center
    color $c2
    span
      cursor pointer
      &:hover
        color $c1
  .dialogAdyen
    >>>.el-dialog
      margin 5vh auto 0 auto
    >>>.el-dialog__header
      padding 0
  .adyenContent
    position relative
    .close
      position absolute
      right -30px
      top -30px
      font-size 16px
      color #fff
      border-radius 50%
      padding 6px
      border 1px solid rgba(255,255,255,0.5)
      background-color rgba(255,255,255,0.1)
      cursor pointer
      backdrop-filter blur(5px)
@media screen and (max-width: 1800px)
  .miya-purchaseAgent
    .form-box
      .row
        width 66%
@media screen and (max-width: 1500px)
  .miya-purchaseAgent
    .form-box
      .row
        width 70%
@media screen and (max-width: 800px)
  .miya-purchaseAgent
    overflow-y auto
    .title1
      margin-bottom 1rem
      line-height 1.5rem
    .form-box
      padding-bottom 0
      .row
        width 100%
        margin-bottom 1rem
        .name
          .tip
            flex 1
        .type-price
          position relative
          margin-top 1rem
    .price-box
      position relative
      display block
      border-top none
      .discountCode
        position relative
        left 0
        display block
        background-color transparent
        box-shadow none
        padding 0.5rem
        .selectTotal
          flex-wrap wrap
      .price
        padding 0 0.5rem 0.5rem 0.5rem
      .btns
        display block
        .info-btn
          width 100%
          margin 0.5rem auto 0.5rem auto
        .payBtn
          margin-left 0
          width 100%
        .pay-box
          bottom 0
    .adyenContent
      position relative
      .close
        top -32px
        right -5px
</style>
<style lang="stylus">
.miya-purchaseAgent
  .el-button--info.is-disabled, .el-button--info.is-disabled:active, .el-button--info.is-disabled:focus, .el-button--info.is-disabled:hover
    background #D0CFCE
    border 1px solid #D0CFCE
  .row
    .el-select
      width 100%
    .el-input-number--medium
      width 100%
    .el-input-number .el-input__inner
      background-color $c7
  .error
    .el-input__inner
      border 1px solid $c10
      background-color rgba(255,57,35, 0.1)
  .el-dialog__body
    padding 0 24px 0 24px
</style>
